

































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Menu from '@/components/common/Menu.vue';
import AddPublicIpAddressDialog from './AddPublicIpAddressDialog.vue';
import { format } from 'date-fns';
import { limitsService } from '@/services/LimitsService';
import { mapState } from 'vuex';
import { storeService } from '@/services/StoreService';

@Component({
  components: {
    Menu,
    PublicIpAddressesTable,
    AddPublicIpAddressDialog,
  },
  computed: {
    ...mapState({
      userRole: (state: any) => state.currentWorkspace.role,
      workspaceData: (state: any) =>
        state.workspaces.workspaces.find(
          (item: any) => parseInt(item.id, 10) === parseInt(state.currentWorkspace.id, 10)
        ) || {},
    }),
  },
})
export default class PublicIpAddressesTable extends Vue {
  workspaceId = 0;
  regionId = 0;
  isModalShown = false;
  isLoading = 2;
  publicIPAddresses = [];
  publicIPAddressesLimit = 0;
  limitExceeded = false;
  price = {};

  @Watch('$store.state.publicIPAddresses.public_ip_addresses', { immediate: true, deep: true })
  onAddressesChange(data: any) {
    if (data) {
      this.publicIPAddresses = data;
    }
  }

  @Watch('$store.state.publicIPAddresses.price', { immediate: true, deep: true })
  onPriceChange(data: any) {
    if (data) {
      this.price = data;
    }
  }

  formatDate(date: string) {
    return date ? format(new Date(date), 'dd.MM.yyyy') : '';
  }

  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
    this.getPublicIpAddresses();
    limitsService.getLimits(this.workspaceId, this.regionId).then((data: any) => {
      this.publicIPAddressesLimit = data.public_networks;
      this.isLoading -= 1;
    });
    this.limitExceeded = this.publicIPAddresses.length >= this.publicIPAddressesLimit;
  }

  getPublicIpAddresses() {
    storeService.getPublicAddresses().then(() => {
      this.isLoading -= 1;
    });
  }

  closeAddDialog() {
    this.getPublicIpAddresses();
    this.isModalShown = false;
  }
}
